import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import '../styles/FloatingContact.css';

const FloatingContact = () => {
    const [isOpen, setIsOpen] = useState(false);

    const contacts = [
        {
            platform: 'WhatsApp',
            username: '+62 812 3511 9573',
            url: 'https://wa.me/6281235119573',
            icon: '/wa.webp',
        },
        {
            platform: 'Instagram',
            username: '@_nandanannn',
            url: 'https://www.instagram.com/_nandanannn',
            icon: '/ig.webp',
        },
        {
            platform: 'GitHub',
            username: 'nandanannn24',
            url: 'https://github.com/nandanannn24',
            icon: '/github.webp',
        },
        {
            platform: 'Email',
            username: 'sipalingnanda@gmail.com',
            url: 'mailto:sipalingnanda@gmail.com',
            icon: '/email.webp',
        },
    ];

    return (
        <div className="floating-contact-container">
            {/* FAB Button */}
            <button
                className={`floating-contact-btn ${isOpen ? 'open' : ''}`}
                onClick={() => setIsOpen(!isOpen)}
                aria-label="Contact options"
            >
                <span className="contact-btn-icon">+</span>
            </button>

            {/* Contact Options */}
            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        className="contact-options"
                        initial={{ opacity: 0, y: 20, scale: 0.9, pointerEvents: 'none' }}
                        animate={{ opacity: 1, y: 0, scale: 1, pointerEvents: 'auto' }}
                        exit={{ opacity: 0, y: 10, scale: 0.95, pointerEvents: 'none' }}
                        transition={{ type: 'spring', stiffness: 400, damping: 25 }}
                    >
                        {contacts.map((contact, index) => (
                            <motion.a
                                key={index}
                                href={contact.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="contact-option"
                                onClick={() => setIsOpen(false)}
                                initial={{ opacity: 0, x: 20 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: 10 }}
                                transition={{ type: 'spring', stiffness: 300, damping: 25, delay: index * 0.05 }}
                                whileHover={{ x: -4, transition: { duration: 0.2 } }}
                            >
                                <div className="option-icon">
                                    <img
                                        src={contact.icon}
                                        alt={contact.platform}
                                        onError={(e) => {
                                            e.target.style.display = 'none';
                                            e.target.parentElement.textContent = contact.platform.charAt(0);
                                        }}
                                    />
                                </div>
                                <div className="option-info">
                                    <span className="option-platform">{contact.platform}</span>
                                    <span className="option-username">{contact.username}</span>
                                </div>
                            </motion.a>
                        ))}
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default FloatingContact;